import { useEffect, useState } from "react";

//components
import Lottie from "react-lottie";
import { Button, Grid, TextField, Typography } from "@mui/material";

//hooks
import { useSignup } from "hooks/auth";
//providers
import { useUserState } from "providers/UserProvider";
import { setAuthCookie, setUserInStorage } from "lib/Storage";

//assets
import loadingAnimation from "assets/lotties/rightPanelLoading.json";

const styles = {
  inputField: {
    color: "#55ff55",
    borderColor: "#55ff55",
    borderWidth: "1px",
    borderStyle: "solid",
    borderRadius: "5px",
    padding: "0.5%",
    width: "100%",
    margin: "1%",
  },
};

function SignupPanel(props) {
  const [user, setUser] = useUserState();
  const {
    frequency,
    password,
    passwordRepeat,
    referralCode,
    currentTypingFocus,
    setRightState,
    setCurrentTypingFocus,
    resetInputValues
  } = props;

  const [blinkingCursor, setBlinkingCursor] = useState(false);
  const { mutate, isLoading } = useSignup();

  const submitFunction = () => {
    mutate(
      { username: frequency, password: password, referralCode: referralCode },
      {
        onSuccess: (response) => {
          if (response && response.status === "OK") {
            setUser(response.user);
            setAuthCookie(response.userToken);
            setUserInStorage(response.user);
            setRightState("navigator");
            resetInputValues();
          }
        },
        onError: (error) => {
          // console.log(error);
        },
      }
    );
  };

  useEffect(() => {
    const blinkingCursorInterval = setInterval(() => {
      setBlinkingCursor((current) => !current);
    }, 500);

    return () => {
      clearInterval(blinkingCursorInterval);
    };
  }, []);

  return <>
    {isLoading ? (
      <Lottie
        options={{
          loop: true,
          autoplay: true,
          animationData: loadingAnimation,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
          },
          initialSegment: [11, 121],
        }}
        height={"100%"}
        width={"80%"}
      />
    ) : (
      <Grid
        Container
        style={{
          height: "100%",
          padding: "5%",
          paddingTop: "0%",
          alignSelf: "center",
          paddingRight: "10%",
          overflow: "auto",
        }}
      >
        <Grid
          container
          spacing={2}
          style={{ width: "100%", height: "100%", alignItems: "center" }}
        >
          <Grid item xs={10}>
            <Grid
              item
              container
              style={{ height: "50%", alignItems: "center" }}
            >
              <Grid item xs={6}>
                <Typography style={{ color: "wheat", align: "center" }}>
                  Frequency
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <TextField
                  variant="standard"
                  id="frequencyInput"
                  value={`${frequency}${
                    currentTypingFocus === "frequency" && blinkingCursor
                      ? "_"
                      : ""
                  }`}
                  InputProps={{
                    readOnly: true,
                    style: styles.inputField,
                  }}
                  InputLabelProps={{
                    style: { color: "wheat" },
                  }}
                  onClick={() => {
                    setCurrentTypingFocus("frequency");
                  }} />
              </Grid>
            </Grid>
            <Grid
              item
              container
              style={{ height: "50%", alignItems: "center" }}
            >
              <Grid item xs={6}>
                <Typography style={{ color: "wheat" }}>Password</Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  variant="standard"
                  id="PasswordInput"
                  // label="Password"
                  value={`${new Array(password.length).join("*")}${
                    currentTypingFocus === "password" || password === ""
                      ? password.slice(-1)
                      : "*"
                  }${
                    currentTypingFocus === "password" && blinkingCursor
                      ? "_"
                      : ""
                  }`}
                  InputProps={{
                    readOnly: true,
                    style: styles.inputField,
                  }}
                  InputLabelProps={{
                    style: { color: "wheat" },
                  }}
                  onClick={() => {
                    setCurrentTypingFocus("password");
                  }} />
              </Grid>
            </Grid>

            <Grid
              item
              container
              style={{ height: "50%", alignItems: "center" }}
            >
              <Grid item xs={6}>
                <Typography style={{ color: "wheat" }}>
                  Repeat Pass
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  variant="standard"
                  id="PasswordRepeatInput"
                  value={`${new Array(passwordRepeat?.length).join("*")}${
                    currentTypingFocus === "passwordRepeat" ||
                    passwordRepeat === ""
                      ? passwordRepeat.slice(-1)
                      : "*"
                  }${
                    currentTypingFocus === "passwordRepeat" && blinkingCursor
                      ? "_"
                      : ""
                  }`}
                  InputProps={{
                    readOnly: true,
                    style: styles.inputField,
                  }}
                  InputLabelProps={{
                    style: { color: "wheat" },
                  }}
                  onClick={() => {
                    setCurrentTypingFocus("passwordRepeat");
                  }} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={2} style={{ height: "50%" }}>
            <Grid item container style={{ alignItems: "center" }}>
              <Button
                type="submit"
                size="large"
                style={{
                  backgroundColor: "#55ff5500",
                  color: "#00FF00",
                  borderColor: "#00FF00",
                  borderWidth: "1px",
                  borderStyle: "solid",
                  margin: "1%",
                  height: "100%",
                  padding: "1%",
                }}
                variant="contained"
                onClick={submitFunction}
              >
                Signup
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )}
  </>;
}

export default SignupPanel;
